import React, { PureComponent } from 'react';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib-commonjs/Dialog';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { connect } from 'react-redux';
import { Checkbox } from 'office-ui-fabric-react';
import { getUserGeolocationLog, saveUserAgreementLog } from '../../lib/agreement-log';

class AgreementDialog extends PureComponent {
  constructor(props) {
    super(props);
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    // console.log(`constructor mo: ${currentMonth} min: ${currentMonth} dt:${currentDate.getFullYear()}-${currentDate.getMonth()}`);
    const hasAgreedToTerms = localStorage.getItem(`agreedToTerms${currentMonth}`);
    this.state = {
      hidden: true, // !( hasAgreedToTerms === null || false ),
      title: this.props.content[this.props.lang].agreementTitle,
      content: this.props.content[this.props.lang].agreenmentText,
      checkAgreed: false,
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.user !== prevState.user) {
      if (this.props.user) {
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth();
        const hasAgreedToTerms = localStorage.getItem(`agreedToTerms${currentMonth}`);
        const hasUpdatedData = !!this.hasUpdatedB2CData();

        if (this.state.hidden === true && !hasAgreedToTerms && hasUpdatedData)
          this.setState({ hidden: false });
      }
    }
  }

  handleAgreed = async () => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();

    // remove previous
    if (localStorage.getItem(`agreedToTerms`)) {
      localStorage.removeItem(`agreedToTerms`);
    }
    for (let i = 0; i < 12; i++) {
      if (localStorage.getItem(`agreedToTerms${i}`)) {
        localStorage.removeItem(`agreedToTerms${i}`);
      }
    }

    localStorage.setItem(`agreedToTerms${currentMonth}`, true);
    this.setState({ hidden: true });

    console.log({ user: this.props.user });
    if (this.props.user) {
      console.log('Save user Data here!');
      const { displayName, givenName, surname, mail, id, extension_Phone, state } = this.props.user;
      const { agreementLogToken } = this.props.resourcesTokens;
      const geo = await getUserGeolocationLog();
      const agreementPayload = {
        userId: id,
        agreementTimestamp: new Date(),
        IPAddress: geo.IPv4,
        country_name: geo.country_name,
        latitude: geo.latitude,
        longitude: geo.longitude,
        state: geo.state,
        city: geo.city,
        userEmail: mail,
        extension_Phone,
        fullName: `${givenName} ${surname}`,
        givenName,
        surname,
      };

      saveUserAgreementLog(agreementPayload, agreementLogToken.tableToken).then(
        (result) => {
          if (result) {
            console.info({ result });
          }
        },
        (err) => {
          console.log(`Failed to update users default localization data: ${err.message}`);
        },
      );
    }
  };

  hasUpdatedB2CData = () => {
    const requiredProperties = [
      'givenName',
      'surname',
      'mobilePhone',
      'companyName',
      'country',
      'state',
      'city',
      'postalCode',
      'jobTitle',
    ];

    return requiredProperties.every((prop) => !!this.props.b2cData[prop]);
  };

  render() {
    const minWidth = parseInt((window.innerWidth * 0.7).toString(), 10);
    const { checkAgreed } = this.state;
    return (
      <div>
        <Dialog
          modalProps={{
            isBlocking: true,
          }}
          dialogContentProps={{
            type: DialogType.normal,
            title: this.state.title,
          }}
          hidden={this.state.hidden}
          onDismiss={() => this.handleDialogClose}
          minWidth={minWidth}
          maxWidth={minWidth}>
          <div>
            {this.state.content.split("\n").map(( string, ndx ) => ( <p key={ndx}>{string}</p> ))}
          </div>
          <DialogFooter>
            <div style={cssStyles.dialogFooterCss}>
              <Checkbox
                label={'Agreed to terms'}
                onChange={(evt, checked) => {
                  evt.preventDefault();
                  this.setState({ checkAgreed: checked });
                }}
              />
              <div style={cssStyles.checkboxSpacer}>&nbsp;</div>
              <PrimaryButton disabled={!checkAgreed} onClick={this.handleAgreed} text="Ok" />
            </div>
          </DialogFooter>
        </Dialog>
      </div>
    );
  }
}

const cssStyles = {
  dialogFooterCss: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'center',
    justifyContent: 'flex-end',
    alignContent: 'center',
  },
  checkboxSpacer: {
    marginRight: '10px',
  },
};

const mapStateToProps = (state) => {
  return {
    lang: state.localization.lang,
    content: state.localization.content,
    user: state.authentication.user,
    b2cData: state.authentication.b2cData,
  };
};

export default connect(mapStateToProps, null)(AgreementDialog);



// WEBPACK FOOTER //
// ./src/components/AgreementDialog/AgreementDialog.js